<template>
    <multi-select-input
        :items="orderedUsers"
        value-key-name="id"
        label-key-name="name"
        v-bind="$attrs"
    >
        <template #active-label="{ bindings }">
            <flex-container
                align-items="center"
                gap="xs"
                inline
                size="auto"
            >
                <user-avatar
                    v-if="bindings.value?.name.abbreviation || bindings.value?.avatar"
                    :placeholder="bindings.value.name.abbreviation"
                    size="md"
                    :url="bindings.value.avatar ? resizedToSizeUploadUrl(bindings.value.avatar, 'md') : ''"
                    :alt="bindings.value?.name.fullName"
                />
                <span v-if="bindings.value?.name.fullName">
                    &nbsp;{{ bindings.value.name.fullName }}
                </span>
                <span v-else>
                    Kies een gebruiker
                </span>
            </flex-container>
        </template>
        <template #item="{ bindings }">
            <span style="display:flex; align-items: center;">
                <user-avatar
                    :placeholder="bindings.item.name.abbreviation"
                    size="md"
                    :url="bindings.item.avatar ? resizedToSizeUploadUrl(bindings.item.avatar, 'md') : ''"
                    :alt="bindings.item.name.fullName"
                />
                <span>&nbsp;{{ bindings.item.name.fullName }}</span>
            </span>
        </template>
    </multi-select-input>
</template>

<script lang="ts" setup>
    import { MultiSelectInput, UserAvatar } from '@keyvue/one-ui';
    import { resizedToSizeUploadUrl } from '@/utils/resize';
    import type { User } from '@keyvue/one-api-client';
    import { computed } from 'vue';

    export interface Props {
        users: User[]
    }

    const props = defineProps<Props>();

    const orderedUsers = computed(() => (
        [...props.users].sort((a, b) => a.name.fullName.localeCompare(b.name.fullName))
    ));
</script>
